import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
// import 'element-plus/lib/theme-chalk/index.css'
// import './assets/css/reset.min.css'
import 'element-plus/dist/index.css'

import './assets/css/reset.min.css'
import './assets/css/global.scss'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'


import animated from "animate.css"

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

createApp(App)
    .use(store)
    .use(router)
    .use(ElementPlus, { locale: zhCn, })
    .use(animated)
    .mount('#app')
